/**
 * Error Boundary para capturar erros de renderização e evitar tela em branco.
 * Útil para diagnosticar tela branca ao abrir link do QR no mobile: o erro é exibido e logado.
 */

import React from 'react';
import { logAppError } from '@/services/loggingService';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logAppError(error?.message ?? String(error), error?.stack ?? errorInfo?.componentStack ?? '');
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            background: '#1f2937',
            color: '#e5e7eb',
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
            fontSize: 14,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <h1 style={{ color: '#f87171', marginBottom: 16 }}>Algo deu errado</h1>
          <p style={{ marginBottom: 8 }}>
            O app encontrou um erro. Isso ajuda a diagnosticar tela em branco ao abrir o link do QR no celular.
          </p>
          <pre
            style={{
              background: '#374151',
              padding: 12,
              borderRadius: 8,
              overflow: 'auto',
              maxWidth: '100%',
              textAlign: 'left',
              fontSize: 12,
            }}
          >
            {this.state.error?.message ?? String(this.state.error)}
          </pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 16,
              padding: '10px 20px',
              background: '#7c3aed',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
            }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
